export default __webpack_public_path__ + "static/media/empty-page-horizontal.bb58db3d.png";